module.exports = __webpack_public_path__ + "static/media/header-text.e1a6236f.png";


//////////////////
// WEBPACK FOOTER
// ./public/header-text.png
// module id = 190
// module chunks = 0